// extracted by mini-css-extract-plugin
export var icon = "_62-1";
export var subtext = "_62-0";